import styled, { css } from 'styled-components';
import { Input } from 'reactstrap';

const getSemanticBorderDefault = ({ theme }) =>
  theme.colors.semantic.border.default;

const getSemanticSurfaceCard = ({ theme }) =>
  theme.colors.semantic.surface.card;

const getSemanticSurfaceMuted = ({ theme }) =>
  theme.colors.semantic.surface.muted;

const getSemanticTextPrimary = ({ theme }) =>
  theme.colors.semantic.text.primary;

const getSemanticTextSecondary = ({ theme }) =>
  theme.colors.semantic.text.secondary;

const getSemanticActionPrimary = ({ theme }) =>
  theme.colors.semantic.action.primary;

export const StyledInput = styled(Input)`
  border: 1px solid ${getSemanticBorderDefault};
  background-color: ${getSemanticSurfaceCard};
  color: ${getSemanticTextPrimary};

  &.form-control {
    border: 1px solid ${getSemanticBorderDefault};
    background-color: ${getSemanticSurfaceCard};
    color: ${getSemanticTextPrimary};
  }

  &::placeholder {
    color: ${getSemanticTextSecondary};
  }

  &:hover {
    border-color: ${getSemanticActionPrimary};
  }

  &:focus,
  &:focus-visible {
    border-color: ${getSemanticActionPrimary};
    background-color: ${getSemanticSurfaceCard};
    color: ${getSemanticTextPrimary};
    box-shadow: none;
  }

  &:disabled {
    cursor: not-allowed;
    border-color: ${getSemanticSurfaceMuted};
    background-color: ${getSemanticSurfaceMuted};
    color: ${getSemanticTextSecondary};
  }

  ${props =>
    props.invalid &&
    css`
      border-color: ${props.theme.colors.danger500};

      &:hover,
      &:focus,
      &:focus-visible {
        border-color: ${props.theme.colors.danger500};
      }
    `}
`;
